export type User = {
  id: string;
  name: string;
  email: string;
  upn?: string;
  avatar: string;
  id_token: string;
  access_token: string;
  provider?: "google" | "entra";
} | null;

export const SET_USER = "SET_USER";

export const UNSET_USER = "UNSET_USER";

interface SetUserAction {
  type: typeof SET_USER;
  user: User;
}

interface UnsetUserAction {
  type: typeof UNSET_USER;
}

export type UserState = User | null;

export type UserAction = SetUserAction | UnsetUserAction;
